// dateModes.js — named date-range "intents" that re-resolve against today.
// A saved view stores the MODE (e.g. "last_3_months"), never literal dates, so a
// range saved months ago always resolves to the current period on load. A literal
// "custom" range is session-only and never persisted (see useSavedView).
import {
   startOfMonth,
   endOfMonth,
   subMonths,
   startOfQuarter,
   endOfQuarter,
} from "date-fns";

export const DATE_MODES = [
   { value: "this_month", label: "This month" },
   { value: "last_month", label: "Last month" },
   { value: "last_3_months", label: "Last 3 months" },
   { value: "this_quarter", label: "This quarter" },
   { value: "custom", label: "Custom" },
];

export const isPresetMode = (mode) => DATE_MODES.some((m) => m.value === mode && m.value !== "custom");

// Resolve a preset mode to a concrete { startDate, endDate, key } range as of `now`.
// Returns null for "custom" (the caller keeps the literal range it already has).
export function resolveDateMode(mode, now = new Date()) {
   let startDate;
   let endDate;
   switch (mode) {
      case "this_month":
         startDate = startOfMonth(now);
         endDate = endOfMonth(now);
         break;
      case "last_month": {
         const prev = subMonths(now, 1);
         startDate = startOfMonth(prev);
         endDate = endOfMonth(prev);
         break;
      }
      case "last_3_months":
         startDate = startOfMonth(subMonths(now, 2)); // this month + prior 2 = 3 months
         endDate = endOfMonth(now);
         break;
      case "this_quarter":
         startDate = startOfQuarter(now);
         endDate = endOfQuarter(now);
         break;
      default:
         return null; // "custom" or unknown — caller keeps its current literal range
   }
   return { startDate, endDate, key: "selection" };
}
